import { combineReducers } from 'redux';

import addressFormat from 'redux/addressFormats/reducers';
import allocation from 'redux/allocations/reducers';
import apiError from 'redux/apiErrors/reducers';
import cart from 'redux/cart/reducers';
import checkout from 'redux/checkout/reducers';
import clubMemberShipment from 'redux/clubMemberShipments/reducers';
import clubMembership from 'redux/clubMemberships/reducers';
import clubPackage from 'redux/clubPackages/reducers';
import clubSignup from 'redux/clubSignup/reducers';
import clubSubscriptionShipment from 'redux/clubSubscriptionShipments/reducers';
import club from 'redux/clubs/reducers';
import collection from 'redux/collections/reducers';
import customer from 'redux/customer/reducers';
import customerAddress from 'redux/customerAddresses/reducers';
import customerCreditCard from 'redux/customerCreditCards/reducers';
import customerDashboard from 'redux/customerDashboard/reducers';
import customerGiftCard from 'redux/customerGiftCard/reducers';
import customerLoyalty from 'redux/customerLoyalty/reducers';
import customerLoyaltySummary from 'redux/customerLoyaltySummary/reducers';
import customerMetaData from 'redux/customerMetaData/reducers';
import customerPastPurchases from 'redux/customerPastPurchases/reducers';
import customerProductRating from 'redux/customerProductRating/reducers';
import form from 'redux/forms/reducers';
import inventoryLocation from 'redux/inventoryLocations/reducers';
import layout from 'redux/layout/reducers';
import localization from 'redux/localization/reducers';
import modal from 'redux/modal/reducers';
import order from 'redux/orders/reducers';
import personalizationBlock from 'redux/personalizationBlock/reducers';
import productFilter from 'redux/productFilters/reducers';
import productTemplate from 'redux/productTemplates/reducers';
import product from 'redux/products/reducers';
import reservationAvailability from 'redux/reservationAvailabilities/reducers';
import reservationCart from 'redux/reservationCart/reducers';
import reservationType from 'redux/reservationTypes/reducers';
import reservation from 'redux/reservations/reducers';
import setting from 'redux/settings/reducers';
import shipping from 'redux/shipping/reducers';

import loyaltyPointsAvailability from './redux/loyaltyPointsAvailability/reducers';

const rootReducer = combineReducers({
  apiError,
  addressFormat,
  allocation,
  cart,
  checkout,
  club,
  clubMembership,
  clubMemberShipment,
  clubPackage,
  clubSignup,
  clubSubscriptionShipment,
  collection,
  customer,
  customerPastPurchases,
  customerAddress,
  customerCreditCard,
  customerDashboard,
  customerGiftCard,
  customerLoyalty,
  customerLoyaltySummary,
  customerMetaData,
  form,
  inventoryLocation,
  layout,
  loyaltyPointsAvailability,
  localization,
  modal,
  order,
  personalizationBlock,
  product,
  productFilter,
  productTemplate,
  reservationAvailability,
  reservationCart,
  reservation,
  reservationType,
  setting,
  shipping,
  customerProductRating
});

export default rootReducer;
